export default __webpack_public_path__ + "6cbf715d4068ff530e03d5137b9d8180.jpg";